import { render, staticRenderFns } from "./initPage.vue?vue&type=template&id=2e64259a&scoped=true&"
import script from "./initPage.vue?vue&type=script&lang=js&"
export * from "./initPage.vue?vue&type=script&lang=js&"
import style0 from "./initPage.vue?vue&type=style&index=0&id=2e64259a&prod&scoped=true&lang=scss&"
import style1 from "./initPage.vue?vue&type=style&index=1&id=2e64259a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e64259a",
  null
  
)

export default component.exports